var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClicks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: " currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m16.5 3-.518.498M7.5 3l.599.639M5.962 6.947h1.08m9.755-.175h1.361m-6.26-4.613V1M4.96 13.698l-.185.102.085-.043c-.845.534-1.116 1.604-.598 2.443l4.96 6.8h6.684c2.864-.051 5.138-2.338 5.092-5.034l-.064-3.79-6.773-1.085-.102-5.969c0-2.992-4.155-2.915-4.155.077l.158 9.235c.011.676-.288.769-.67.208l-1.9-2.227c-.555-.817-1.701-1.103-2.609-.67l-.02.01.097-.057Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClicks);
export default __webpack_public_path__ + "static/media/clicks.3d1d3a091df516c6ca928d2df0c6d665.svg";
export { ForwardRef as ReactComponent };